import React, {useEffect, useRef, useState} from "react";
import {MedicationV3} from "../../types";
import MedicationCardOptions from "./medication-options-card";
import {generateMedicationDropdownText} from "../../../utils/med-widget-utils";
import MedicationPriceCardV3 from "./medication-price-card-v3";

export interface MedicationCardV3Props {
    medications: MedicationV3[];
}

const generateDropdownItemsForMedication = (medications: MedicationV3[]) => {
    const dropdownItems: JSX.Element[] = [];
    medications.forEach((medication, index) => dropdownItems.push(
        <pui-dropdown-item-two type="option" key={'medication' + index} label={generateMedicationDropdownText(medication)}
                               value={index}></pui-dropdown-item-two>));
    return dropdownItems;
}

const generateMedicationUniqueID = (medication: MedicationV3) => {
    return JSON.stringify(medication.medicationInfo);
}

const onShowMedCardButtonClick = () => {
    const medicationCardMainEl = document.querySelector<HTMLElement>('.main-medication-card-container');
    if (medicationCardMainEl) {
        medicationCardMainEl.style.display = "block";
    }
    const buttonEl = document.querySelector<HTMLElement>(".show-medication-card-button");
    if (buttonEl) {
        buttonEl.style.display = "None";
    }
}

const MedicationCardV3 = ({medications}: MedicationCardV3Props) => {
    const [selectedMedicationIndex, setSelectedMedicationIndex] = useState<number>(0);
    const medicationRef = useRef();

    useEffect(() => {
        const medicationEl: any = medicationRef.current;
        medicationEl.onSelect = (newValue: number) => {
            setSelectedMedicationIndex(newValue);
        }
    }, []);

    return (
        <pui-section class="medication-widget-v3" flowDirection="vertical" fullWidth>
            <pui-section flowDirection="horizontal" fullWidth mainAxisArrangement="center">
                <button className="show-medication-card-button pui-button product-card-button-secondary" type="button"
                        onClick={onShowMedCardButtonClick}>
                    Estimate price for a specific medication
                </button>
            </pui-section>
            <div className='main-medication-card-container'>
                <MedicationPriceCardV3/>
                <pui-heading class="medication-dropdowns-heading" spacingtop="small" spacingbottom="small" input="Edit medication details:"></pui-heading>
                <pui-dropdown-two class="medication-options-dropdown" name="medication"
                                  label="MEDICATION" disableShowOptionsIfSingle
                                  selectedText={generateMedicationDropdownText(medications[selectedMedicationIndex])} value='0' ref={medicationRef}>
                    {generateDropdownItemsForMedication(medications)}
                </pui-dropdown-two>
                <MedicationCardOptions key={generateMedicationUniqueID(medications[selectedMedicationIndex])}
                                       medication={medications[selectedMedicationIndex]}/>
            </div>
        </pui-section>
    );
}

export default MedicationCardV3;
